var App = require('app');
var Consts = require('consts');
var Misc = require('utils/misc');

var RemoteDevice = Marionette.Object.extend({
    isStarting: false,
    isStopping: false,
    isRunning: false,
    startErrorTimeout: 60000,
    receivedData: false,
    controller: undefined,
    retryCountSecs: 45,
    errorTimeoutSecs: 30,
    lastRetry: undefined,
    baseApi: '/api/v1/devices/$deviceId/remote-control',
    status: {
        refresh: undefined,
        error: undefined,
        sending: false,
    },
    content: undefined,
    ajaxQueue: [],
    startRetryMaxCount: 3,
    // API
    start: function (onSuccess, onError, doClearQueue) {
        var self = this;
        this.startRetryCount = this.startRetryMaxCount;
        this.status.invalidDevice = false;
        this.status.wantAbort = false;
        this.status.isRetrying = false;
        this.isStarting = true;
        this.receivedData = false;
        this.lastRetry = new Date().getTime();
        this.startTime = new Date().getTime();
        if (this.status.emptyScreenCount) this.status.emptyScreenCount = 0;

        var runStartCommand = function () {
            self.status.timestamp = undefined;
            self.command(
                { cmd: Consts.RemoteControlCmd.ScreenStart },
                function () {
                    self.isStarting = false;
                    self.isRunning = true;
                    if (onSuccess) onSuccess();
                },
                function (err) {
                    var errMsg = err.responseText || '';
                    self.isStarting = false;

                    if (errMsg.indexOf('gateway already in screen capture mode') != -1) {
                        self.startRetryCount--;
                        if (self.startRetryCount) {
                            runStartCommand();
                            return;
                        }
                    }

                    self.startTime = new Date().getTime();

                    if (errMsg.indexOf('The remote control is busy') != -1) {
                        self.status.invalidDevice = true;
                    }

                    if (onError) onError();
                },
                doClearQueue
            );
        };

        runStartCommand();
    },
    update: function (onSuccess, onError, noMessagingPresence) {
        var self = this;

        var handleError = function (err) {
            self.status.error = err;
            if (onError) onError(err);
            return;
        };

        this.requestData(
            function (data) {
                // OK
                self.decodeData(data);
                var screenError = self.checkScreenErrors(data);

                self.status.invalidDevice = false;
                if (data.device_error && data.device_error.indexOf('Invalid device. Active device:') != -1) {
                    self.status.invalidDevice = true;
                }

                var updateContent = function () {
                    if (data.device.timestamp !== self.status.timestamp) {
                        if (self.status.refresh !== 1) self.status.refresh = 1;
                        else self.status.refresh = 0;

                        if (self.status.timestamp && self.status.timestamp < data.device.timestamp) {
                            self.status.timestampDiff = (data.device.timestamp - self.status.timestamp) / 1000000;
                        }
                        self.status.timestamp = data.device.timestamp;
                    }
                    self.status.spectatorCount = data.messaging.participants
                        ? Math.max(data.messaging.participants.length - 1, 0)
                        : 0;
                    self.applyControllerData(data);
                    var currentTime = new Date().getTime();
                    if (screenError) {
                        if (
                            (!self.isStarting && currentTime - self.startTime > self.startErrorTimeout) ||
                            self.receivedData
                        ) {
                            self.status.error = screenError;
                        }
                    } else {
                        self.status.error = false;
                        self.receivedData = true;
                    }

                    if (onSuccess) onSuccess();
                };

                if (self.content) {
                    updateContent();
                } else {
                    self.buildContent(
                        function () {
                            // OK
                            updateContent();
                        },
                        function () {
                            // ERROR
                            handleError(data);
                        }
                    );
                }
            },
            function (data) {
                // ERROR
                handleError(data);
            },
            noMessagingPresence
        );
    },
    stopCommand: function (onDone, onError, doClearQueue) {
        var self = this;
        this.status.isRetrying = false;
        this.command(
            { cmd: Consts.RemoteControlCmd.ScreenStop },
            function () {
                self.isStopping = false;
                self.isRunning = true;
                if (onDone) onDone();
            },
            function () {
                self.isStopping = false;
                if (onError) onError();
            },
            true
        );

        this.isStopping = true;
    },

    command: function (cmdData, onDone, onError, doClearQueue) {
        var url = this.getBaseAPI();
        var self = this;

        cmdData.station = this.controller.get('station');
        cmdData.key = this.controller.get('key_number');
        if (doClearQueue) {
            this.status.sending = false;
            this.ajaxQueue = [];
        }

        this.ajaxQueue.push({
            url: url,
            method: 'POST',
            data: JSON.stringify(cmdData),
            success: function () {
                if (onDone) onDone();

                // send the next cmd (if there is one)
                self.status.sending = false;
                self.send();
            },
            error: function (err) {
                if (onError) {
                    onError(err, cmdData);
                }
                self.status.sending = false;
                self.send();
            },
        });

        if (!this.status.sending) this.send();
    },
    send: function () {
        if (this.ajaxQueue.length == 0) return;

        this.status.sending = true;
        var firstAjax = this.ajaxQueue.shift();
        App.ajax(firstAjax);
    },
    allowModeSelect: function (ms, value, msIdx) {
        if (ms === undefined) ms = this.content.selector[msIdx];

        var virtualModeSelected = ms.currentPos >= ms.modePosFrom && ms.currentPos <= ms.modePosTill;
        var c1 = value == ms.currentPosHW && (ms.currentPos < ms.modePosFrom || ms.currentPos > ms.modePosTill);
        var c2 =
            (ms.currentPosHW != ms.manualModePos || virtualModeSelected) &&
            ms.currentPos != ms.manualModePos &&
            (value < ms.modePosFrom || value > ms.modePosTill);

        return c1 || c2;
    },
    // LOGIC
    initialize: function (initData) {
        this.controller = initData.controller;
    },

    checkScreenErrors: function (deviceData) {
        if (this.isRunning != this.isLastRunning) {
            this.isLastRunning = this.isRunning;
        }

        var currentTime = new Date().getTime();
        var self = this;

        if (deviceData.device && deviceData.device.data && this.content) {
            this.lastRetry = currentTime; // when the data are ok, the retry time will start from this point
            this.status.isRetrying = false;
        }

        if (deviceData.device && !deviceData.device.data && this.content && !this.isStarting && !this.isStopping) {
            var lastCorrectScreenDiff = currentTime - this.lastRetry;
            // timeout not exceeded => no need to do anything
            if (lastCorrectScreenDiff < this.errorTimeoutSecs * 1000) return;

            if (lastCorrectScreenDiff > this.retryCountSecs * 1000 && this.isRunning) {
                var onComplete = function () {
                    currentTime = new Date().getTime();
                    self.lastRetry = currentTime;
                };

                this.status.wantAbort = false;
                this.status.isRetrying = true;
                this.command(
                    { cmd: Consts.RemoteControlCmd.ScreenStart, value: 1 },
                    function () {
                        onComplete();
                    },
                    function (err) {
                        onComplete();
                        self.status.wantAbort =
                            err.responseText &&
                            err.responseText.indexOf &&
                            err.responseText.indexOf('gateway already in screen capture mode') != -1;
                        self.status.error = self.status.error || self.status.wantAbort;
                    }
                );
                this.lastRetry = currentTime;
            }
            return 'no screen';
        }
    },

    requestData: function (onSuccess, onError, noMessagingPresence) {
        App.ajax({
            cache: false,
            data: noMessagingPresence ? 'recordpresence=0' : '',
            url: this.getBaseAPI(),
            type: 'GET',
            success: function (data) {
                onSuccess(data);
            },
            error: function (data) {
                onError(data);
            },
        });
    },

    buildContent: function (onSuccess, onError) {
        var self = this;
        App.ajax({
            url: this.getBaseAPI() + '/config',
            method: 'GET',
            success: function (configData) {
                self.applyConfigData($.parseXML(configData));
                if (onSuccess) onSuccess();
            },
            error: function () {
                if (onError) onError();
            },
        });
    },

    applyConfigData: function (configData) {
        var root = null;
        if (configData.children) root = configData.children[0];
        else if (configData.childNodes) root = configData.childNodes[0];

        var deviceType = this.controller.get('type');
        var controller = $(root).find('controller[id="' + deviceType + '"]');
        var templateName = $(controller).attr('template');
        var template = $(root).find('template[id="' + templateName + '"]');

        var firstOf = function (x) {
            if (x.length > 0) return x[0];
            else return undefined;
        };

        template = firstOf(template);
        controller = firstOf(controller);

        this.content = {};

        Misc.loadFromDOMElement(this.content, template);
        Misc.loadFromDOMElement(this.content, controller);
    },

    applyControllerData: function (data) {
        this.content = $.extend(true, this.content, data);
        var switches = ['rotary_switch_top', 'rotary_switch_middle', 'rotary_switch_bottom'];
        for (var i = 0; i < switches.length; i++) {
            var key = switches[i];
            if (this.content.selector && this.content.selector[i]) {
                if (this.content.device[key].virtual !== 0) {
                    this.content.selector[i].currentPos = this.content.device[key].virtual;
                } else if (this.content.device[key].real !== 0) {
                    this.content.selector[i].currentPos = this.content.device[key].real + 1;
                    this.content.selector[i].currentPosHW = this.content.device[key].real + 1;
                }
            }
        }

        if (data.device.is_symbol && this.content.display) {
            this.content.display.showMode = data.device.data.length == 21 ? 1 : 2;
        }
    },

    // UTILS
    getBaseAPI: function () {
        return this.baseApi.replace('$deviceId', this.controller.id);
    },

    decodeData: function (data) {
        function decode_base64(s) {
            var e = {},
                i,
                k,
                v = [],
                r = [],
                w = String.fromCharCode;
            var n = [
                [65, 91],
                [97, 123],
                [48, 58],
                [43, 44],
                [47, 48],
            ];

            for (var z in n) {
                for (var i = n[z][0]; i < n[z][1]; i++) {
                    v.push(w(i));
                }
            }
            for (var i = 0; i < 64; i++) {
                e[v[i]] = i;
            }

            for (var i = 0; i < s.length; i += 72) {
                var b = 0,
                    c,
                    x,
                    l = 0,
                    o = s.substring(i, i + 72);
                for (var x = 0; x < o.length; x++) {
                    c = e[o.charAt(x)];
                    b = (b << 6) + c;
                    l += 6;
                    while (l >= 8) {
                        r.push((b >>> (l -= 8)) % 256);
                    }
                }
            }
            return r;
        }

        if (data.device.data) {
            data.device.data = decode_base64(data.device.data);
            for (var i = 0; i < data.device.data.length - 1; i += 2) {
                var tmp = data.device.data[i + 1];
                data.device.data[i + 1] = data.device.data[i];
                data.device.data[i] = tmp;
            }
        }
    },
});

module.exports = RemoteDevice;
